/**
 * ProvinceSelect Component
 *
 * Dropdown selector for Canadian provinces and territories.
 * Used in Profile form for tax calculation context.
 */

import React from "react";
import type { ProvinceCode } from "../types/settings";
import { PROVINCE_CODES } from "../types/settings";

/** Human-readable labels for each province/territory code */
const PROVINCE_LABELS: Record<ProvinceCode, string> = {
  AB: "Alberta",
  BC: "British Columbia",
  MB: "Manitoba",
  NB: "New Brunswick",
  NL: "Newfoundland and Labrador",
  NS: "Nova Scotia",
  NT: "Northwest Territories",
  NU: "Nunavut",
  ON: "Ontario",
  PE: "Prince Edward Island",
  QC: "Quebec",
  SK: "Saskatchewan",
  YT: "Yukon",
};

export interface ProvinceSelectProps {
  /** Currently selected province code (empty string for no selection) */
  value: string;
  /** Callback with the selected province code */
  onChange: (value: string) => void;
  /** Optional additional class names */
  className?: string;
}

/**
 * ProvinceSelect — Canadian province/territory dropdown
 *
 * Renders a labeled select element with all 13 Canadian provinces
 * and territories. Includes a placeholder option.
 */
export const ProvinceSelect: React.FC<ProvinceSelectProps> = ({
  value,
  onChange,
  className,
}) => {
  return (
    <div className={className}>
      <label htmlFor="province-select" className="province-select-label">
        Province
      </label>
      <select
        id="province-select"
        className="province-select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Select province...</option>
        {PROVINCE_CODES.map((code) => (
          <option key={code} value={code}>
            {PROVINCE_LABELS[code]}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ProvinceSelect;
